import { Component, Input } from '@angular/core';
import { FileService } from '@ca/core/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

const MAX_LINE_LENGTH = 1000;

@Component({
    selector: 'ca-logs-modal',
    templateUrl: './logs-modal.component.html',
    styleUrls: ['./logs-modal.component.scss'],
})
export class LogsModalComponent {
    @Input() logName: string = 'apeer-logs.txt';
    @Input() log?: string;
    @Input() isLoading: boolean = false;
    @Input() maxLineLength = MAX_LINE_LENGTH;

    constructor(
        private activeModal: NgbActiveModal,
        private fileService: FileService,
    ) {}

    dismiss(reason?: string): void {
        this.activeModal.dismiss(reason);
    }

    downloadLogs(): void {
        if (this.log != null) {
            this.fileService.downloadTextfile(this.log, this.logName);
        }
    }
}
